import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../redux/features/modalSlice";
import { successToast, errorToast } from "../Utils/toast";
import { changeStaffPassword } from "../redux/services/Staff Services/Staff.Services";
 
const StaffChangePasswordModal = ({ data }) => {
  const dispatch = useDispatch();
 const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
 
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
 
const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData({
    ...formData,
    [name]: value,
  });

  if (errors[name]) {
    setErrors((prev) => ({
      ...prev,
      [name]: null,
    }));
  }
};
 
  const handleSubmit = async () => {
    const { newPassword, confirmPassword } = formData;
 
  const validationErrors = {};

if (!newPassword) {
  validationErrors.newPassword = "New password is required";
}

if (!confirmPassword) {
  validationErrors.confirmPassword = "Confirm Password is required";
}

if (newPassword && newPassword.length < 6) {
  validationErrors.newPassword =
    "Password must be at least 6 characters";
}

if (
  newPassword &&
  confirmPassword &&
  newPassword !== confirmPassword
) {
  validationErrors.confirmPassword =
    "Passwords do not match";
}

if (Object.keys(validationErrors).length > 0) {
  setErrors(validationErrors);

  setTimeout(() => {
    const firstErrorField =
      document.querySelector(".is-invalid");

    if (firstErrorField) {
      firstErrorField.focus();
    }
  }, 100);

  return;
}
    if (newPassword.length < 6) {
      return errorToast("Password must be at least 6 characters");
    }
 
    if (newPassword !== confirmPassword) {
      return errorToast("Passwords & Confirm Password do not match");
    }
 
    try {
      setLoading(true);
 
      // ✅ Direct payload bhejo - backend ke hisaab se
      const res = await changeStaffPassword({
        staff_id: data?.staffId,
        new_password: newPassword,
        confirm_password: confirmPassword,
      });
 
      if (res?.data?.success) {
        successToast(res?.data?.message || "Password changed successfully");
        dispatch(closeModal());
 
        if (data?.refreshData) {
          data.refreshData();
        }
      } else {
        errorToast(res?.data?.message || "Failed to change password");
      }
    } catch (error) {
      errorToast(
        error?.response?.data?.message ||
        "Failed to change password"
      );
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <>
      <div className="mb-3">
        <h5>{data?.staffName}</h5>
      </div>
 
      <div className="mb-3">
        <label>New Password</label>
        <input
          type="text"
          name="newPassword"
          className="form-control"
          value={data?.staffOldPassword}
          onChange={handleChange}
          readOnly
        />
      </div>
 
      <div className="mb-3">
        <label>New Password<span className="text-danger">*</span></label>
   <input
  type="password"
  name="newPassword"
  className={`form-control ${
    errors?.newPassword ? "is-invalid" : ""
  }`}
  value={formData.newPassword}
  onChange={handleChange}
  disabled={loading}
/>

{errors?.newPassword && (
  <div className="invalid-feedback">
    {errors.newPassword}
  </div>
)}
      </div>
 
      <div className="mb-3">
        <label>Confirm Password<span className="text-danger">*</span></label>
     <input
  type="password"
  name="confirmPassword"
  className={`form-control ${
    errors?.confirmPassword ? "is-invalid" : ""
  }`}
  value={formData.confirmPassword}
  onChange={handleChange}
  disabled={loading}
/>

{errors?.confirmPassword && (
  <div className="invalid-feedback">
    {errors.confirmPassword}
  </div>
)}
      </div>
 
      <div className="d-flex justify-content-end gap-2">
        <button
          className="btn btn-danger"
          onClick={() => dispatch(closeModal())}
          disabled={loading}
        >
          Cancel
        </button>
 
        <button
          className="add-btn"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Updating..." : "Change Password"}
        </button>
      </div>
    </>
  );
};
 
export default StaffChangePasswordModal;